import React from 'react';

import { Link, useNavigate } from 'react-router-dom';

import moment from 'moment';
import { Circle } from 'rc-progress';
import Tooltip from 'rc-tooltip';

import loanAnimation from '../assets/images/Loan animation.gif';
import warningIcon from '../assets/images/warning.png';
import '../assets/styles/loan/Loan.scss';
import configData from '../config/index';

const LoanDashboard = ({ loans }) => {
  const navigate = useNavigate();
  const isBnpl = configData.getTenant() === 'lightrx';
  return (
    <div className={`section ${isBnpl && 'lightrx'} loanSection `}>
      {loans.length > 0 &&
        loans.map(
          ({ loanDetail, loanFundingStatus, approvedLoanAmount, approvedInterestRate, id }) => (
            <div className="activeLoan" key={id} id={id}>
              {loanFundingStatus === 'TO_BE_FUNDED' ||
              loanFundingStatus === 'FUNDING_IN_PROGRESS' ? (
                <div className="balance">
                  <p className="loanInfo">
                    {approvedInterestRate}% APR{' '}
                    {configData?.dashboard?.dashboardStatusMap?.PENDING_FUNDS?.fundExactAmount
                      ? 'for'
                      : 'up to'}{' '}
                    {approvedLoanAmount?.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    })}
                  </p>
                  <h3 className="loanSummary">
                    {configData?.dashboard?.dashboardStatusMap?.PENDING_FUNDS?.summary}
                  </h3>
                  <img className="loanAnimation" src={loanAnimation} />
                </div>
              ) : (
                <div className={`balance ${isBnpl && 'lightrx'}`}>
                  <h3 className="loanTitle">{`Loan #${loanDetail?.acctrefno}`}</h3>
                  <div className="remainingBalance">
                    <div className="remainingBalanceTitle">
                      {!isBnpl && <div className="badge grey" />}
                      <h4>Remaining Balance</h4>
                    </div>
                    <div className="remainingBalanceAmount">
                      <h3>{`${loanDetail?.currentPayoffBalance?.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                      })}`}</h3>

                      <div className="links">
                        <div className="links__viewStatement">
                          <Link to={`/account/${loanDetail.acctrefno}/statements`}>
                            View Statements
                          </Link>
                        </div>
                        <div className="links__viewDocuments">
                          <Link to={`/account/${loanDetail.acctrefno}/documents`}>
                            View Documents
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="paidBalance">
                    <div className="digitalData">
                      <div className="divider" />
                      <div className="digitalDataContent">
                        {!isBnpl && <div className="badge blue" />}
                        <div className="paidItemTexts">
                          <div className="paidItemText">
                            <span>Paid</span>
                            {loanDetail?.totalPastDue > 0 && (
                              <span className="warning">Payment Past Due</span>
                            )}
                            <span>Next Payment Due</span>
                            <span>Next Payment</span>
                          </div>
                          <div className="paidItemValue">
                            <span>
                              {(
                                loanDetail?.currentNoteAmount - loanDetail?.currentPrincipalBalance
                              ).toLocaleString('en-us', {
                                style: 'currency',
                                currency: 'USD',
                              })}
                            </span>
                            {loanDetail?.totalPastDue > 0 && (
                              <div className="payment-past-due-tooltip-container">
                                <span className="warning">
                                  {loanDetail?.totalPastDue?.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                  })}
                                </span>
                                <Tooltip
                                  placement="right"
                                  overlayInnerStyle={{ fontSize: '18px', maxWidth: '250px' }}
                                  overlay={
                                    <span>
                                      You are behind on your loan payment. Please use the Make One
                                      Time Payment button to make a payment
                                    </span>
                                  }
                                >
                                  <img src={warningIcon} />
                                </Tooltip>
                              </div>
                            )}
                            <span>
                              {loanDetail?.nextPaymentDue
                                ? loanDetail?.nextPaymentDue?.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                  })
                                : ''}
                            </span>
                            <span>
                              {moment(loanDetail?.nextPaymentDate).isValid()
                                ? moment(loanDetail?.nextPaymentDate).format('MMMM D, YYYY')
                                : ''}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="divider" />
                      <div className="btnGroup actions">
                        <button
                          className="btn secondary-btn"
                          onClick={() => navigate(`/account/${loanDetail?.acctrefno}/payment`)}
                        >
                          Make One Time Payment
                        </button>
                        <button
                          className="btn primary-btn"
                          onClick={() => {
                            navigate(`/account/${loanDetail?.acctrefno}`);
                          }}
                        >
                          View Details on this Loan
                        </button>
                      </div>
                    </div>

                    <div className="visualData">
                      <Circle
                        percent={
                          ((loanDetail.currentNoteAmount - loanDetail.currentPrincipalBalance) /
                            loanDetail.currentNoteAmount) *
                          100
                        }
                        strokeLinecap="square"
                        strokeColor="#5fb7b5"
                        strokeWidth="4"
                        trailWidth="4"
                        width="303px"
                        height="269px"
                      />
                    </div>
                  </div>

                  {isBnpl ? (
                    <div className="link-section__mobile">
                      <div className="divider" />
                      <div
                        className="link-section__mobile__link"
                        onClick={() => navigate(`/account/${loanDetail.acctrefno}/statements`)}
                      >
                        view statements
                      </div>
                      <div className="divider" />
                      <div
                        className="link-section__mobile__link"
                        onClick={() => navigate(`/account/${loanDetail.acctrefno}/documents`)}
                      >
                        view documents
                      </div>
                      <div className="divider" />
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          )
        )}
    </div>
  );
};

export default LoanDashboard;
